"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var MoreOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M213.333 426.667a85.333 85.333 0 110 170.666 85.333 85.333 0 010-170.666zm298.667 0a85.333 85.333 0 110 170.666 85.333 85.333 0 010-170.666zm298.667 0a85.333 85.333 0 110 170.666 85.333 85.333 0 010-170.666z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
MoreOutlined.displayName = "MoreOutlined";
var _default = exports["default"] = MoreOutlined;